<template>
  <KvEditor
    :value="editorValue"
    :placeholder="placeholder"
    :height="height"
    :variant="variant"
    :size="size"
    :disabled="disabled"
    :has-error="hasError"
    @input="handleInput"
  />
</template>

<script>
import KvEditor from "../../components/inputs/kv-editor.vue";

export default {
  name: "BenefitsRichText",
  components: {
    KvEditor,
  },
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    value: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    height: {
      type: [String, Number],
      default: "180px",
    },
    variant: {
      type: String,
      default: "outlined",
    },
    size: {
      type: String,
      default: "large",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    editorValue() {
      return { html: this.value || "" };
    },
  },
  methods: {
    handleInput(payload) {
      this.$emit("input", !payload || payload.isEmpty || payload.empty ? "" : payload.html);
    },
  },
};
</script>
